// Traductions pour toutes les langues supportées
export const translations = {
  fr: {
    // Navigation
    home: 'Accueil',
    logout: 'Déconnexion',
    language: 'Langue',
    
    // Login Page
    welcome: 'Bienvenue',
    login: 'Connexion',
    signup: 'Inscription',
    email: "nom@domaine.tld",
    password: 'Mot de passe',
    passwordMin: 'Mot de passe (≥ 8 caractères)',
    confirmPassword: 'Confirmez le mot de passe',
    optionalUsername: "Nom d'utilisateur (optionnel)",
    createAccount: 'Créer un compte',
    rememberMe: 'Se souvenir de moi',
    loginFooter: 'Gérez vos paniers d\'achats en toute fluidité.\nUnifiez vos produits, images et liens au même endroit.',
    downloadExtension: 'Télécharger l\'extension',
    installExtensionHelp: 'Comment l\'installer',
    
    // Carts Page
    searchCart: 'Rechercher',
    noCarts: 'Aucun panier pour le moment',
    createFirstCart: 'Créez votre premier panier et commencez à ajouter vos produits.',
    createCart: 'Créer un panier',
    totalEstimated: 'Total estimé',
    modified: 'Modifié',
    manageBudgets: 'Gérez vos budgets et produits',
    withImagesLinks: 'Avec images, liens et multiples indices de certitudes',
    newCart: '+ Nouveau panier',
    createNewCart: 'Créer un nouveau panier',
    cartName: 'Nom du panier',
    budget: 'Budget',
    budgetOptional: 'Budget (optionnel)',
    cancel: 'Annuler',
    create: 'Créer',
    renameCart: 'Renommer le panier',
    rename: 'Renommer',
    deleteCart: 'Supprimer',
    duplicateCart: 'Dupliquer',
    confirmDelete: 'Supprimer définitivement',
    compare: 'Comparer',
    compareCarts: 'Comparaison de paniers',
    selectCartToCompare: 'Sélectionner un panier à comparer',
    selectTwoCarts: 'Veuillez sélectionner deux paniers à comparer',
    backToCarts: 'Retour aux paniers',
    exportReport: 'Exporter le rapport',
    difference: 'Différence',
    uniqueItems: 'items uniques',
    unique: 'Unique',
    priceDifference: 'Différence de prix',
    items: 'articles',
    loading: 'Chargement',
    compareWithOther: 'Comparer avec un autre panier',
    noOtherCartToCompare: 'Aucun autre panier à comparer.',
    matchingRule: 'Règle de correspondance',
    
    // Cart Detail Page
    back: 'Retour',
    search: 'Rechercher…',
    tools: 'Outils',
    library: 'Bibliothèque',
    addProduct: 'Ajouter un produit',
    articles: 'Articles',
    total: 'Total',
    budgetRemaining: 'Budget restant',
    budgetAdjustment: 'Redressement budgétaire requis',
    setBudget: 'Définir le budget',
    editBudget: 'Modifier le budget',
    budgetAmount: 'Montant du budget',
    save: 'Enregistrer',
    add: 'Ajouter',
    edit: 'Modifier',
    delete: 'Supprimer',
    openLink: 'Ouvrir le lien',
    refreshPrice: 'Actualiser le prix',
    pasteImage: 'Coller une image',
    moveToSaved: 'Mettre de côté',
    deleteProduct: 'Supprimer ce produit ?',
    editProduct: 'Modifier le produit',
    productName: 'Nom du produit',
    link: 'Lien',
    price: 'Prix',
    quantity: 'Quantité',
    promo: 'Promotion',
    certainty: 'Niveau de certitude',
    image: 'Image',
    noItems: 'Aucun produit dans ce panier',
    addFirstProduct: 'Ajoutez votre premier produit pour commencer.',
    
    // Tools Menu
    exportJSON: 'Export JSON',
    exportCSV: 'Export CSV',
    exportPDF: 'Export PDF',
    exportHTML: 'Export HTML',
    import: 'Importer',
    paste: 'Coller',
    
    // Selection Dock
    selected: 'Sélectionné',
    openLinks: 'Ouvrir les liens',
    copy: 'Copier',
    deleteSelected: 'Supprimer',
    
    // Modals
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    warning: 'Attention',
    info: 'Information',
    confirm: 'Confirmer',
    dismiss: 'Fermer',
    
    // Notifications
    notifications: 'Notifications',
    noNotifications: 'Aucune notification',
    markAllAsRead: 'Tout marquer comme lu',
    markAllRead: 'Tout lire',
    clearAll: 'Tout effacer',
    clear: 'Effacer',
    justNow: 'À l\'instant',
    minutesAgo: 'min',
    hoursAgo: 'h',
    daysAgo: 'j',
    
    // Budget notifications
    budgetExceeded: 'Budget dépassé',
    budgetExceededMessage: 'Budget dépassé de {amount}. Ajustement requis.',
    budgetWarning: 'Budget bientôt atteint',
    budgetWarningMessage: 'Budget utilisé à {percentage} %. Il reste {remaining}.',
    
    // Advanced Filters
    advancedFilters: 'Filtres avancés',
    resetFilters: 'Réinitialiser',
    priceRange: 'Plage de prix',
    minPrice: 'Prix min',
    maxPrice: 'Prix max',
    certaintyLevel: 'Niveau de certitude',
    hasImage: 'Image',
    hasLink: 'Lien',
    filterWith: 'Avec',
    filterWithout: 'Sans',
    dateAdded: 'Date d\'ajout',
    all: 'Tous',
    yes: 'Oui',
    no: 'Non',
    today: 'Aujourd\'hui',
    lastWeek: 'Semaine dernière',
    lastMonth: 'Mois dernier',
    lastYear: 'Année dernière',
    close: 'Fermer',
    listView: 'Vue liste',
    gridView: 'Vue grille',
    
    // Certitude levels
    veryLow: 'Très faible',
    low: 'Faible',
    medium: 'Moyenne',
    high: 'Élevée',
    veryHigh: 'Quasi certain',
    
    // Library
    searchLibrary: 'Rechercher dans la bibliothèque…',
    libraryEmpty: 'Aucun élément dans la bibliothèque',
    deleteFromLibrary: 'Supprimer de la bibliothèque ?',
    productDeleted: 'Produit supprimé',
    productDeletedFromLibrary: 'Produit supprimé de la bibliothèque avec succès',
    addToCart: 'Ajouter au panier',
    preview: 'Aperçu',
    pasteImageLabel: 'Coller l\'image',
    linkUrl: 'Lien (URL)',
    priceEuro: 'Prix (€)',
    promoLabel: 'Promo',
    imageUrl: 'Image (URL)',
    
    // Global Search
    globalSearch: 'Rechercher',
    enterSearchQuery: 'Entrez une requête de recherche',
    searchInAllCarts: 'La recherche parcourt tous les paniers et la bibliothèque',
    searching: 'Recherche en cours',
    carts: 'Paniers',
    products: 'Produits',
    inCart: 'Dans le panier',
    inLibrary: 'Dans la bibliothèque',
    viewLink: 'Voir le lien',
    noResults: 'Aucun résultat trouvé',
    tryDifferentQuery: 'Essayez une autre requête de recherche',
    
    // Price History
    priceHistory: 'Historique des prix',
    noPriceHistory: 'Aucun relevé de prix enregistré',
    priceHistoryHint: 'L’historique apparaîtra après de prochains relevés enregistrés.',
    currentPrice: 'Prix actuel',
    averagePrice: 'Prix moyen',
    minPrice: 'Prix min',
    maxPrice: 'Prix max',
    priceChange: 'Variation',
    detailedHistory: 'Historique détaillé',
  },
  
  en: {
    home: 'Home',
    logout: 'Logout',
    language: 'Language',
    welcome: 'Welcome',
    login: 'Login',
    signup: 'Sign Up',
    email: "email@domain.com",
    password: 'Password',
    passwordMin: 'Password (≥ 8 characters)',
    confirmPassword: 'Confirm password',
    optionalUsername: 'Username (optional)',
    createAccount: 'Create account',
    rememberMe: 'Remember me',
    loginFooter: 'Manage your shopping carts with ease.\nUnify your products, images and links in one place.',
    downloadExtension: 'Download the extension',
    installExtensionHelp: 'How to install it',
    searchCart: 'Search a cart…',
    noCarts: 'No carts yet',
    createFirstCart: 'Create your first cart and start adding your products.',
    createCart: 'Create a cart',
    totalEstimated: 'Estimated total',
    modified: 'Modified',
    createNewCart: 'Create a new cart',
    cartName: 'Cart name',
    budget: 'Budget',
    budgetOptional: 'Budget (optional)',
    cancel: 'Cancel',
    create: 'Create',
    renameCart: 'Rename cart',
    rename: 'Rename',
    deleteCart: 'Delete',
    duplicateCart: 'Duplicate',
    confirmDelete: 'Permanently delete',
    compare: 'Compare',
    compareCarts: 'Compare Carts',
    selectCartToCompare: 'Select a cart to compare',
    selectTwoCarts: 'Please select two carts to compare',
    backToCarts: 'Back to carts',
    exportReport: 'Export report',
    difference: 'Difference',
    uniqueItems: 'unique items',
    unique: 'Unique',
    priceDifference: 'Price difference',
    items: 'items',
    loading: 'Loading',
    manageBudgets: 'Manage your budgets and products',
    withImagesLinks: 'With images, links and multiple certainty indices',
    newCart: '+ New cart',
    back: 'Back',
    search: 'Search…',
    tools: 'Tools',
    library: 'Library',
    addProduct: 'Add product',
    articles: 'Items',
    total: 'Total',
    budgetRemaining: 'Budget remaining',
    budgetAdjustment: 'Budget adjustment required',
    setBudget: 'Set budget',
    editBudget: 'Edit budget',
    budgetAmount: 'Budget amount',
    save: 'Save',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    openLink: 'Open link',
    pasteImage: 'Paste image',
    moveToSaved: 'Move to saved',
    deleteProduct: 'Delete this product?',
    editProduct: 'Edit product',
    productName: 'Product name',
    link: 'Link',
    price: 'Price',
    quantity: 'Quantity',
    promo: 'Promotion',
    certainty: 'Certainty level',
    image: 'Image',
    noItems: 'No products in this cart',
    addFirstProduct: 'Add your first product to get started.',
    exportJSON: 'Export JSON',
    exportCSV: 'Export CSV',
    exportPDF: 'Export PDF',
    exportHTML: 'Export HTML',
    import: 'Import',
    paste: 'Paste',
    selected: 'Selected',
    openLinks: 'Open links',
    copy: 'Copy',
    deleteSelected: 'Delete',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    veryLow: 'Very low',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    veryHigh: 'Almost certain',
    listView: 'List view',
    gridView: 'Grid view',
    
    // Global Search
    globalSearch: 'Search in all carts...',
    enterSearchQuery: 'Enter a search query',
    searchInAllCarts: 'Search across all carts and library',
    searching: 'Searching',
    carts: 'Carts',
    products: 'Products',
    inCart: 'In cart',
    inLibrary: 'In library',
    viewLink: 'View link',
    noResults: 'No results found',
    tryDifferentQuery: 'Try a different search query',
    
    // Price History
    priceHistory: 'Price History',
    noPriceHistory: 'No recorded price observations',
    priceHistoryHint: 'History will appear after future recorded observations.',
    currentPrice: 'Current Price',
    averagePrice: 'Average Price',
    minPrice: 'Min Price',
    maxPrice: 'Max Price',
    priceChange: 'Change',
    detailedHistory: 'Detailed History',
  },
  
  es: {
    home: 'Inicio',
    logout: 'Cerrar sesión',
    language: 'Idioma',
    welcome: 'Bienvenido',
    login: 'Iniciar sesión',
    signup: 'Registrarse',
    email: "correo@dominio.com",
    password: 'Contraseña',
    passwordMin: 'Contraseña (≥ 8 caracteres)',
    confirmPassword: 'Confirmar contraseña',
    optionalUsername: 'Nombre de usuario (opcional)',
    createAccount: 'Crear cuenta',
    rememberMe: 'Recuérdame',
    loginFooter: 'Gestiona tus carritos de compras con facilidad.\nUnifica tus productos, imágenes y enlaces en un solo lugar.',
    searchCart: 'Buscar un carrito…',
    noCarts: 'Aún no hay carritos',
    createFirstCart: 'Crea tu primer carrito y comienza a agregar tus productos.',
    createCart: 'Crear un carrito',
    totalEstimated: 'Total estimado',
    modified: 'Modificado',
    createNewCart: 'Crear un nuevo carrito',
    cartName: 'Nombre del carrito',
    budget: 'Presupuesto',
    budgetOptional: 'Presupuesto (opcional)',
    cancel: 'Cancelar',
    create: 'Crear',
    renameCart: 'Renombrar carrito',
    rename: 'Renombrar',
    deleteCart: 'Eliminar',
    duplicateCart: 'Duplicar',
    confirmDelete: 'Eliminar permanentemente',
    compare: 'Comparar',
    compareCarts: 'Comparación de carritos',
    selectCartToCompare: 'Seleccionar un carrito para comparar',
    selectTwoCarts: 'Por favor seleccione dos carritos para comparar',
    backToCarts: 'Volver a los carritos',
    exportReport: 'Exportar informe',
    difference: 'Diferencia',
    uniqueItems: 'artículos únicos',
    unique: 'Único',
    priceDifference: 'Diferencia de precio',
    items: 'artículos',
    loading: 'Cargando',
    manageBudgets: 'Gestiona tus presupuestos y productos',
    withImagesLinks: 'Con imágenes, enlaces y múltiples índices de certeza',
    newCart: '+ Nuevo carrito',
    back: 'Volver',
    search: 'Buscar…',
    tools: 'Herramientas',
    library: 'Biblioteca',
    addProduct: 'Agregar producto',
    articles: 'Artículos',
    total: 'Total',
    budgetRemaining: 'Presupuesto restante',
    budgetAdjustment: 'Ajuste presupuestario requerido',
    setBudget: 'Establecer presupuesto',
    editBudget: 'Editar presupuesto',
    budgetAmount: 'Monto del presupuesto',
    save: 'Guardar',
    add: 'Agregar',
    edit: 'Editar',
    delete: 'Eliminar',
    openLink: 'Abrir enlace',
    pasteImage: 'Pegar imagen',
    moveToSaved: 'Mover a guardados',
    deleteProduct: '¿Eliminar este producto?',
    editProduct: 'Editar producto',
    productName: 'Nombre del producto',
    link: 'Enlace',
    price: 'Precio',
    quantity: 'Cantidad',
    promo: 'Promoción',
    certainty: 'Nivel de certeza',
    image: 'Imagen',
    noItems: 'No hay productos en este carrito',
    addFirstProduct: 'Agrega tu primer producto para comenzar.',
    exportJSON: 'Exportar JSON',
    exportCSV: 'Exportar CSV',
    exportPDF: 'Exportar PDF',
    exportHTML: 'Exportar HTML',
    import: 'Importar',
    paste: 'Pegar',
    selected: 'Seleccionado',
    openLinks: 'Abrir enlaces',
    copy: 'Copiar',
    deleteSelected: 'Eliminar',
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    veryLow: 'Muy baja',
    low: 'Baja',
    medium: 'Media',
    high: 'Alta',
    veryHigh: 'Casi segura',
    listView: 'Vista de lista',
    gridView: 'Vista de cuadrícula',
    searchLibrary: 'Buscar en la biblioteca…',
    libraryEmpty: 'No hay elementos en la biblioteca',
    deleteFromLibrary: '¿Eliminar de la biblioteca?',
    productDeleted: 'Producto eliminado',
    productDeletedFromLibrary: 'Producto eliminado de la biblioteca con éxito',
    addToCart: 'Agregar al carrito',
    preview: 'Vista previa',
    pasteImageLabel: 'Pegar imagen',
    linkUrl: 'Enlace (URL)',
    priceEuro: 'Precio (€)',
    promoLabel: 'Promo',
    imageUrl: 'Imagen (URL)',
    
    // Global Search
    globalSearch: 'Buscar en todos los carritos...',
    enterSearchQuery: 'Ingrese una consulta de búsqueda',
    searchInAllCarts: 'La búsqueda recorre todos los carritos y la biblioteca',
    searching: 'Buscando',
    carts: 'Carritos',
    products: 'Productos',
    inCart: 'En el carrito',
    inLibrary: 'En la biblioteca',
    viewLink: 'Ver enlace',
    noResults: 'No se encontraron resultados',
    tryDifferentQuery: 'Pruebe con otra consulta de búsqueda',
    
    // Price History
    priceHistory: 'Historial de precios',
    noPriceHistory: 'No hay observaciones de precio registradas',
    priceHistoryHint: 'El historial aparecerá tras próximas observaciones registradas.',
    currentPrice: 'Precio actual',
    averagePrice: 'Precio promedio',
    minPrice: 'Precio mínimo',
    maxPrice: 'Precio máximo',
    priceChange: 'Variación',
    detailedHistory: 'Historial detallado',
  },
  
  it: {
    home: 'Home',
    logout: 'Esci',
    language: 'Lingua',
    welcome: 'Benvenuto',
    login: 'Accedi',
    signup: 'Registrati',
    email: "email@dominio.com",
    password: 'Password',
    passwordMin: 'Password (≥ 8 caratteri)',
    confirmPassword: 'Conferma password',
    optionalUsername: 'Nome utente (opzionale)',
    createAccount: 'Crea account',
    rememberMe: 'Ricordami',
    loginFooter: 'Gestisci i tuoi carrelli con facilità.\nUnifica i tuoi prodotti, immagini e link in un solo posto.',
    searchCart: 'Cerca un carrello…',
    noCarts: 'Nessun carrello ancora',
    createFirstCart: 'Crea il tuo primo carrello e inizia ad aggiungere i tuoi prodotti.',
    createCart: 'Crea un carrello',
    totalEstimated: 'Totale stimato',
    modified: 'Modificato',
    createNewCart: 'Crea un nuovo carrello',
    cartName: 'Nome del carrello',
    budget: 'Budget',
    budgetOptional: 'Budget (opzionale)',
    cancel: 'Annulla',
    create: 'Crea',
    renameCart: 'Rinomina carrello',
    rename: 'Rinomina',
    deleteCart: 'Elimina',
    duplicateCart: 'Duplica',
    confirmDelete: 'Elimina permanentemente',
    manageBudgets: 'Gestisci i tuoi budget e prodotti',
    withImagesLinks: 'Con immagini, link e multipli indici di certezza',
    newCart: '+ Nuovo carrello',
    back: 'Indietro',
    search: 'Cerca…',
    tools: 'Strumenti',
    library: 'Libreria',
    addProduct: 'Aggiungi prodotto',
    articles: 'Articoli',
    total: 'Totale',
    budgetRemaining: 'Budget rimanente',
    budgetAdjustment: 'Adeguamento budget richiesto',
    setBudget: 'Imposta budget',
    editBudget: 'Modifica budget',
    budgetAmount: 'Importo del budget',
    save: 'Salva',
    add: 'Aggiungi',
    edit: 'Modifica',
    delete: 'Elimina',
    openLink: 'Apri link',
    pasteImage: 'Incolla immagine',
    moveToSaved: 'Sposta in salvati',
    deleteProduct: 'Eliminare questo prodotto?',
    editProduct: 'Modifica prodotto',
    productName: 'Nome prodotto',
    link: 'Link',
    price: 'Prezzo',
    quantity: 'Quantità',
    promo: 'Promozione',
    certainty: 'Livello di certezza',
    image: 'Immagine',
    noItems: 'Nessun prodotto in questo carrello',
    addFirstProduct: 'Aggiungi il tuo primo prodotto per iniziare.',
    exportJSON: 'Esporta JSON',
    exportCSV: 'Esporta CSV',
    exportPDF: 'Esporta PDF',
    exportHTML: 'Esporta HTML',
    import: 'Importa',
    paste: 'Incolla',
    selected: 'Selezionato',
    openLinks: 'Apri link',
    copy: 'Copia',
    deleteSelected: 'Elimina',
    loading: 'Caricamento...',
    error: 'Errore',
    success: 'Successo',
    veryLow: 'Molto bassa',
    low: 'Bassa',
    medium: 'Media',
    high: 'Alta',
    veryHigh: 'Quasi certa',
    searchLibrary: 'Cerca nella biblioteca…',
    libraryEmpty: 'Nessun elemento nella biblioteca',
    deleteFromLibrary: 'Eliminare dalla biblioteca?',
    productDeleted: 'Prodotto eliminato',
    productDeletedFromLibrary: 'Prodotto eliminato dalla biblioteca con successo',
    addToCart: 'Aggiungi al carrello',
    preview: 'Anteprima',
    pasteImageLabel: 'Incolla immagine',
    linkUrl: 'Link (URL)',
    priceEuro: 'Prezzo (€)',
    promoLabel: 'Promo',
    imageUrl: 'Immagine (URL)',
  },
  
  pt: {
    home: 'Início',
    logout: 'Sair',
    language: 'Idioma',
    welcome: 'Bem-vindo',
    login: 'Entrar',
    signup: 'Registrar',
    email: "email@dominio.com",
    password: 'Senha',
    passwordMin: 'Senha (≥ 8 caracteres)',
    confirmPassword: 'Confirmar senha',
    optionalUsername: 'Nome de usuário (opcional)',
    createAccount: 'Criar conta',
    rememberMe: 'Lembrar-me',
    loginFooter: 'Gerencie seus carrinhos de compras com facilidade.\nUnifique seus produtos, imagens e links em um só lugar.',
    searchCart: 'Buscar um carrinho…',
    noCarts: 'Ainda não há carrinhos',
    createFirstCart: 'Crie seu primeiro carrinho e comece a adicionar seus produtos.',
    createCart: 'Criar um carrinho',
    totalEstimated: 'Total estimado',
    modified: 'Modificado',
    createNewCart: 'Criar um novo carrinho',
    cartName: 'Nome do carrinho',
    budget: 'Orçamento',
    budgetOptional: 'Orçamento (opcional)',
    cancel: 'Cancelar',
    create: 'Criar',
    renameCart: 'Renomear carrinho',
    rename: 'Renomear',
    deleteCart: 'Excluir',
    duplicateCart: 'Duplicar',
    confirmDelete: 'Excluir permanentemente',
    manageBudgets: 'Gerencie seus orçamentos e produtos',
    withImagesLinks: 'Com imagens, links e múltiplos índices de certeza',
    newCart: '+ Novo carrinho',
    back: 'Voltar',
    search: 'Buscar…',
    tools: 'Ferramentas',
    library: 'Biblioteca',
    addProduct: 'Adicionar produto',
    articles: 'Itens',
    total: 'Total',
    budgetRemaining: 'Orçamento restante',
    budgetAdjustment: 'Ajuste orçamentário necessário',
    setBudget: 'Definir orçamento',
    editBudget: 'Editar orçamento',
    budgetAmount: 'Valor do orçamento',
    save: 'Salvar',
    add: 'Adicionar',
    edit: 'Editar',
    delete: 'Excluir',
    openLink: 'Abrir link',
    pasteImage: 'Colar imagem',
    moveToSaved: 'Mover para salvos',
    deleteProduct: 'Excluir este produto?',
    editProduct: 'Editar produto',
    productName: 'Nome do produto',
    link: 'Link',
    price: 'Preço',
    quantity: 'Quantidade',
    promo: 'Promoção',
    certainty: 'Nível de certeza',
    image: 'Imagem',
    noItems: 'Nenhum produto neste carrinho',
    addFirstProduct: 'Adicione seu primeiro produto para começar.',
    exportJSON: 'Exportar JSON',
    exportCSV: 'Exportar CSV',
    exportPDF: 'Exportar PDF',
    exportHTML: 'Exportar HTML',
    import: 'Importar',
    paste: 'Colar',
    selected: 'Selecionado',
    openLinks: 'Abrir links',
    copy: 'Copiar',
    deleteSelected: 'Excluir',
    loading: 'Carregando...',
    error: 'Erro',
    success: 'Sucesso',
    veryLow: 'Muito baixa',
    low: 'Baixa',
    medium: 'Média',
    high: 'Alta',
    veryHigh: 'Quase certa',
    searchLibrary: 'Buscar na biblioteca…',
    libraryEmpty: 'Nenhum elemento na biblioteca',
    deleteFromLibrary: 'Excluir da biblioteca?',
    productDeleted: 'Produto removido',
    productDeletedFromLibrary: 'Produto removido da biblioteca com sucesso',
    addToCart: 'Adicionar ao carrinho',
    preview: 'Visualização',
    pasteImageLabel: 'Colar imagem',
    linkUrl: 'Link (URL)',
    priceEuro: 'Preço (€)',
    promoLabel: 'Promo',
    imageUrl: 'Imagem (URL)',
  },
  
  de: {
    home: 'Startseite',
    logout: 'Abmelden',
    language: 'Sprache',
    welcome: 'Willkommen',
    login: 'Anmelden',
    signup: 'Registrieren',
    email: "email@domain.de",
    password: 'Passwort',
    passwordMin: 'Passwort (≥ 8 Zeichen)',
    confirmPassword: 'Passwort bestätigen',
    optionalUsername: 'Benutzername (optional)',
    createAccount: 'Konto erstellen',
    rememberMe: 'Angemeldet bleiben',
    loginFooter: 'Verwalten Sie Ihre Einkaufswagen mühelos.\nVereinheitlichen Sie Ihre Produkte, Bilder und Links an einem Ort.',
    searchCart: 'Einen Warenkorb suchen…',
    noCarts: 'Noch keine Warenkörbe',
    createFirstCart: 'Erstellen Sie Ihren ersten Warenkorb und beginnen Sie, Ihre Produkte hinzuzufügen.',
    createCart: 'Warenkorb erstellen',
    totalEstimated: 'Geschätzte Summe',
    modified: 'Geändert',
    createNewCart: 'Neuen Warenkorb erstellen',
    cartName: 'Warenkorbname',
    budget: 'Budget',
    budgetOptional: 'Budget (optional)',
    cancel: 'Abbrechen',
    create: 'Erstellen',
    renameCart: 'Warenkorb umbenennen',
    rename: 'Umbenennen',
    deleteCart: 'Löschen',
    duplicateCart: 'Duplizieren',
    confirmDelete: 'Permanent löschen',
    manageBudgets: 'Verwalten Sie Ihre Budgets und Produkte',
    withImagesLinks: 'Mit Bildern, Links und mehreren Gewissheitsindizes',
    newCart: '+ Neuer Warenkorb',
    back: 'Zurück',
    search: 'Suchen…',
    tools: 'Werkzeuge',
    library: 'Bibliothek',
    addProduct: 'Produkt hinzufügen',
    articles: 'Artikel',
    total: 'Gesamt',
    budgetRemaining: 'Verbleibendes Budget',
    budgetAdjustment: 'Budgetanpassung erforderlich',
    setBudget: 'Budget festlegen',
    editBudget: 'Budget bearbeiten',
    budgetAmount: 'Budgetbetrag',
    save: 'Speichern',
    add: 'Hinzufügen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    openLink: 'Link öffnen',
    pasteImage: 'Bild einfügen',
    moveToSaved: 'Zu gespeicherten verschieben',
    deleteProduct: 'Dieses Produkt löschen?',
    editProduct: 'Produkt bearbeiten',
    productName: 'Produktname',
    link: 'Link',
    price: 'Preis',
    quantity: 'Menge',
    promo: 'Promotion',
    certainty: 'Gewissheitsgrad',
    image: 'Bild',
    noItems: 'Keine Produkte in diesem Warenkorb',
    addFirstProduct: 'Fügen Sie Ihr erstes Produkt hinzu, um zu beginnen.',
    exportJSON: 'JSON exportieren',
    exportCSV: 'CSV exportieren',
    exportPDF: 'PDF exportieren',
    exportHTML: 'HTML exportieren',
    import: 'Importieren',
    paste: 'Einfügen',
    selected: 'Ausgewählt',
    openLinks: 'Links öffnen',
    copy: 'Kopieren',
    deleteSelected: 'Löschen',
    loading: 'Laden...',
    error: 'Fehler',
    success: 'Erfolg',
    veryLow: 'Sehr niedrig',
    low: 'Niedrig',
    medium: 'Mittel',
    high: 'Hoch',
    veryHigh: 'Fast sicher',
    searchLibrary: 'In der Bibliothek suchen…',
    libraryEmpty: 'Keine Elemente in der Bibliothek',
    deleteFromLibrary: 'Aus der Bibliothek löschen?',
    productDeleted: 'Produkt entfernt',
    productDeletedFromLibrary: 'Produkt erfolgreich aus der Bibliothek entfernt',
    addToCart: 'Zum Warenkorb hinzufügen',
    preview: 'Vorschau',
    pasteImageLabel: 'Bild einfügen',
    linkUrl: 'Link (URL)',
    priceEuro: 'Preis (€)',
    promoLabel: 'Promo',
    imageUrl: 'Bild (URL)',
  },
  
  ar: {
    home: 'الرئيسية',
    logout: 'تسجيل الخروج',
    language: 'اللغة',
    welcome: 'مرحباً',
    login: 'تسجيل الدخول',
    signup: 'إنشاء حساب',
    email: "البريد@النطاق.com",
    password: 'كلمة المرور',
    passwordMin: 'كلمة المرور (≥ 8 أحرف)',
    confirmPassword: 'تأكيد كلمة المرور',
    optionalUsername: 'اسم المستخدم (اختياري)',
    createAccount: 'إنشاء حساب',
    rememberMe: 'تذكرني',
    loginFooter: 'إدارة عربات التسوق الخاصة بك بسهولة.\nتوحيد منتجاتك وصورك وروابطك في مكان واحد.',
    searchCart: 'البحث عن عربة…',
    noCarts: 'لا توجد عربات بعد',
    createFirstCart: 'أنشئ عربتك الأولى وابدأ في إضافة منتجاتك.',
    createCart: 'إنشاء عربة',
    totalEstimated: 'المجموع المقدر',
    modified: 'معدل',
    createNewCart: 'إنشاء عربة جديدة',
    cartName: 'اسم العربة',
    budget: 'الميزانية',
    budgetOptional: 'الميزانية (اختياري)',
    cancel: 'إلغاء',
    create: 'إنشاء',
    renameCart: 'إعادة تسمية العربة',
    rename: 'إعادة تسمية',
    deleteCart: 'حذف',
    duplicateCart: 'نسخ',
    confirmDelete: 'حذف نهائي',
    manageBudgets: 'إدارة ميزانياتك ومنتجاتك',
    withImagesLinks: 'مع الصور والروابط ومؤشرات اليقين المتعددة',
    newCart: '+ عربة جديدة',
    back: 'رجوع',
    search: 'بحث…',
    tools: 'أدوات',
    library: 'المكتبة',
    addProduct: 'إضافة منتج',
    articles: 'عناصر',
    total: 'المجموع',
    budgetRemaining: 'الميزانية المتبقية',
    budgetAdjustment: 'تعديل الميزانية مطلوب',
    setBudget: 'تعيين الميزانية',
    editBudget: 'تعديل الميزانية',
    budgetAmount: 'مبلغ الميزانية',
    save: 'حفظ',
    add: 'إضافة',
    edit: 'تعديل',
    delete: 'حذف',
    openLink: 'فتح الرابط',
    pasteImage: 'لصق الصورة',
    moveToSaved: 'نقل إلى المحفوظات',
    deleteProduct: 'حذف هذا المنتج؟',
    editProduct: 'تعديل المنتج',
    productName: 'اسم المنتج',
    link: 'الرابط',
    price: 'السعر',
    quantity: 'الكمية',
    promo: 'الترويج',
    certainty: 'مستوى اليقين',
    image: 'الصورة',
    noItems: 'لا توجد منتجات في هذه العربة',
    addFirstProduct: 'أضف منتجك الأول للبدء.',
    exportJSON: 'تصدير JSON',
    exportCSV: 'تصدير CSV',
    exportPDF: 'تصدير PDF',
    exportHTML: 'تصدير HTML',
    import: 'استيراد',
    paste: 'لصق',
    selected: 'محدد',
    openLinks: 'فتح الروابط',
    copy: 'نسخ',
    deleteSelected: 'حذف',
    loading: 'جاري التحميل...',
    error: 'خطأ',
    success: 'نجاح',
    veryLow: 'منخفض جداً',
    low: 'منخفض',
    medium: 'متوسط',
    high: 'عالي',
    veryHigh: 'شبه مؤكد',
    searchLibrary: 'البحث في المكتبة…',
    libraryEmpty: 'لا توجد عناصر في المكتبة',
    deleteFromLibrary: 'حذف من المكتبة؟',
    productDeleted: 'تم حذف المنتج',
    productDeletedFromLibrary: 'تم حذف المنتج من المكتبة بنجاح',
    addToCart: 'إضافة إلى العربة',
    preview: 'معاينة',
    pasteImageLabel: 'لصق الصورة',
    linkUrl: 'الرابط (URL)',
    priceEuro: 'السعر (€)',
    promoLabel: 'الترويج',
    imageUrl: 'الصورة (URL)',
  },
  
  ta: {
    home: 'வீடு',
    logout: 'வெளியேறு',
    language: 'மொழி',
    welcome: 'வரவேற்கிறோம்',
    login: 'உள்நுழைய',
    signup: 'பதிவு செய்',
    email: "மின்னஞ்சல்@களம்.com",
    password: 'கடவுச்சொல்',
    passwordMin: 'கடவுச்சொல் (≥ 8 எழுத்துகள்)',
    confirmPassword: 'கடவுச்சொல்லை உறுதிப்படுத்து',
    optionalUsername: 'பயனர் பெயர் (விருப்பமானது)',
    createAccount: 'கணக்கை உருவாக்கு',
    rememberMe: 'என்னை நினைவில் வை',
    loginFooter: 'உங்கள் வணிக கார்ட்களை எளிதாக நிர்வகிக்கவும்.\nஉங்கள் தயாரிப்புகள், படங்கள் மற்றும் இணைப்புகளை ஒரே இடத்தில் ஒருங்கிணைக்கவும்.',
    searchCart: 'கார்ட்டைத் தேடு…',
    noCarts: 'இன்னும் கார்ட்கள் இல்லை',
    createFirstCart: 'உங்கள் முதல் கார்ட்டை உருவாக்கி உங்கள் தயாரிப்புகளைச் சேர்க்கத் தொடங்குங்கள்.',
    createCart: 'கார்ட்டை உருவாக்கு',
    totalEstimated: 'மதிப்பிடப்பட்ட மொத்தம்',
    modified: 'மாற்றப்பட்டது',
    createNewCart: 'புதிய கார்ட்டை உருவாக்கு',
    cartName: 'கார்ட் பெயர்',
    budget: 'பட்ஜெட்',
    budgetOptional: 'பட்ஜெட் (விருப்பமானது)',
    cancel: 'ரத்து செய்',
    create: 'உருவாக்கு',
    renameCart: 'கார்ட்டை மறுபெயரிடு',
    rename: 'மறுபெயரிடு',
    deleteCart: 'நீக்கு',
    duplicateCart: 'நகலெடு',
    confirmDelete: 'நிரந்தரமாக நீக்கு',
    manageBudgets: 'உங்கள் பட்ஜெட்டுகள் மற்றும் தயாரிப்புகளை நிர்வகிக்கவும்',
    withImagesLinks: 'படங்கள், இணைப்புகள் மற்றும் பல உறுதிப்பாடு குறியீடுகளுடன்',
    newCart: '+ புதிய கார்ட்',
    back: 'பின்',
    search: 'தேடு…',
    tools: 'கருவிகள்',
    library: 'நூலகம்',
    addProduct: 'தயாரிப்பைச் சேர்',
    articles: 'பொருட்கள்',
    total: 'மொத்தம்',
    budgetRemaining: 'மீதமுள்ள பட்ஜெட்',
    budgetAdjustment: 'பட்ஜெட் சரிசெய்தல் தேவை',
    setBudget: 'பட்ஜெட்டை அமை',
    editBudget: 'பட்ஜெட்டை திருத்து',
    budgetAmount: 'பட்ஜெட் தொகை',
    save: 'சேமி',
    add: 'சேர்',
    edit: 'திருத்து',
    delete: 'நீக்கு',
    openLink: 'இணைப்பைத் திற',
    pasteImage: 'படத்தை ஒட்டு',
    moveToSaved: 'சேமிக்கப்பட்டவற்றிற்கு நகர்த்து',
    deleteProduct: 'இந்த தயாரிப்பை நீக்கவா?',
    editProduct: 'தயாரிப்பை திருத்து',
    productName: 'தயாரிப்பு பெயர்',
    link: 'இணைப்பு',
    price: 'விலை',
    quantity: 'அளவு',
    promo: 'தள்ளுபடி',
    certainty: 'உறுதிப்பாடு நிலை',
    image: 'படம்',
    noItems: 'இந்த கார்ட்டில் தயாரிப்புகள் இல்லை',
    addFirstProduct: 'தொடங்க உங்கள் முதல் தயாரிப்பைச் சேர்க்கவும்.',
    exportJSON: 'JSON ஐ ஏற்றுமதி செய்',
    exportCSV: 'CSV ஐ ஏற்றுமதி செய்',
    exportPDF: 'PDF ஐ ஏற்றுமதி செய்',
    exportHTML: 'HTML ஐ ஏற்றுமதி செய்',
    import: 'இறக்குமதி செய்',
    paste: 'ஒட்டு',
    selected: 'தேர்ந்தெடுக்கப்பட்டது',
    openLinks: 'இணைப்புகளைத் திற',
    copy: 'நகலெடு',
    deleteSelected: 'நீக்கு',
    loading: 'ஏற்றுகிறது...',
    error: 'பிழை',
    success: 'வெற்றி',
    veryLow: 'மிகவும் குறைவு',
    low: 'குறைவு',
    medium: 'நடுத்தரம்',
    high: 'உயர்',
    veryHigh: 'கிட்டத்தட்ட உறுதி',
    searchLibrary: 'நூலகத்தில் தேடு…',
    libraryEmpty: 'நூலகத்தில் கூறுகள் இல்லை',
    deleteFromLibrary: 'நூலகத்திலிருந்து நீக்கவா?',
    productDeleted: 'தயாரிப்பு நீக்கப்பட்டது',
    productDeletedFromLibrary: 'நூலகத்திலிருந்து தயாரிப்பு வெற்றிகரமாக நீக்கப்பட்டது',
    addToCart: 'கார்ட்டில் சேர்',
    preview: 'முன்தோற்றம்',
    pasteImageLabel: 'படத்தை ஒட்டு',
    linkUrl: 'இணைப்பு (URL)',
    priceEuro: 'விலை (€)',
    promoLabel: 'தள்ளுபடி',
    imageUrl: 'படம் (URL)',
  },
}

